import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { AttachmentPoint } from '../../models/attachmentpoint';
import { AttachmentPointService } from '../../services/attachment-point.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { GroupService } from '../../services/group.service';
import { GroupLight } from '../../models/group';
import { StationService } from '../../services/station.service';
import { Station } from '../../models/station';

@Component({
  selector: 'app-attachmentpoints-station-binding',
  templateUrl: './attachmentpoints-station-binding.component.html',
  styleUrls: ['./attachmentpoints-station-binding.component.css']
})
export class AttachmentpointsStationBindingComponent implements OnInit {

  attachmentPoints : Array<AttachmentPoint>;
  private visibleStation : Station[];
  @Output() onValidation = new EventEmitter<boolean>();
  
  constructor(private apService : AttachmentPointService,
              public activeModal : NgbActiveModal,
              private stationService : StationService) { }


  ngOnInit() {
  }

  listFormatter(data:any) {
    return data.name;
  }

  onSaveClick() {
    // TODO 
  }

}



// WEBPACK FOOTER //
// ./src/app/attachmentpoints/attachmentpoints-station-binding/attachmentpoints-station-binding.component.ts